import { useEffect, useRef, useState } from 'react'
import renderImage from '../../../../source/importImg'
import styles from './ActionCreateNew.module.css'
import DialogModal from '../../../ReusableComponents/DialogModal/DialogModal'
import { Portal } from '@material-ui/core'

let servoArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]

function ActionCreateTableRow({
    action,
    actionNumber,
    handleSelectAction,
    selectedAction,
    deleteMarker,
    handlePlayAction,
    servoDetailsPopupOpen,
    // isAudioEnable,
    actionNameChange,
    display,
    setDisplay,
    sendReadServoBytes,
    portalPopupRef,
    handelCopyAction,
    isMotorTorqueEnable,
    setShowDeviceConnectModal,
}) {
    const [isShowActionInput, setIsShowActionInput] = useState(false)
    const [isShowError, setIsShowError] = useState(false)
    const [isPlay, setIsPlay] = useState(false)
    const [showDeletePopup, setShowDeletePopup] = useState(false)
    const [inputActionValue, setinputActionValue] = useState(
        action?.actionName || `Action ${actionNumber + 1}`
    )

    const actionInputNameRef = useRef(null)

    const setActionName = () => {
        setIsShowError(false)
        if (inputActionValue.length > 25) {
            setIsShowError(true)
            setTimeout(() => {
                setIsShowError(false)
            }, 2000)
            return
        }
        setIsShowActionInput(false)
        actionNameChange(actionNumber, inputActionValue)
    }

    const handelActionSubmit = (e) => {
        e.preventDefault()
        setActionName()
    }
    const handelReadBtnClick = () => {
        if (selectedAction !== actionNumber || !isMotorTorqueEnable) {
            return
        }
        sendReadServoBytes()
    }

    const playBtnClick = async (event) => {
        try {
            if (isMotorTorqueEnable) {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: 'Please toggle the motor button and enable it to play Actions.',
                })
                return
            }
            if (display !== 'none') {
                setIsPlay(true)
                await handlePlayAction(actionNumber)
                setIsPlay(false)
            }
        } catch (e) {
            setIsPlay(false)
            console.error(e)
        }
    }

    const deleteBtnClick = (event) => {
        // event.stopPropagation()
        if (display !== 'none') {
            setShowDeletePopup(true)
            // deleteMarker(event, actionNumber, action?.id || '')
        }
    }

    const copyBtnClick = (event) => {
        handelCopyAction(actionNumber, action?.id)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                actionInputNameRef.current &&
                !actionInputNameRef.current.contains(event.target)
            )
                setActionName()
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [inputActionValue])
    return (
        <div className={styles.tableRow}>
            <Portal container={portalPopupRef.current}>
                <DialogModal
                    show={showDeletePopup}
                    text={`Are you sure you want to delete  ${
                        action?.actionName || `Action ${actionNumber + 1}`
                    }?`}
                    optionsToSelect={[
                        {
                            text: 'Delete',
                            do: () => {
                                deleteMarker('', actionNumber, action?.id || '')
                            },
                        },
                        {
                            text: 'Cancel',
                            do: () => {
                                setShowDeletePopup(false)
                            },
                        },
                    ]}
                />
            </Portal>

            <div className={styles.tableBodyLeft}>
                <div
                    className={`${styles.tableBodyLeftInner} ${
                        selectedAction === actionNumber
                            ? styles.enabledBtn
                            : styles.disabledBtn
                    }`}
                    onClick={(e) => {
                        if (display !== 'none') {
                            handleSelectAction(actionNumber)
                        }
                    }}
                >
                    <div className={styles.tableBodyMarkaDiv}>
                        <div
                            className={
                                isShowActionInput ? '' : styles.tableBodyActions
                            }
                        >
                            {!isShowActionInput && (
                                <p
                                    onDoubleClick={() => {
                                        setIsShowActionInput(true)
                                    }}
                                    className={
                                        isShowActionInput
                                            ? ''
                                            : styles.tableBodyActionName
                                    }
                                >
                                    {action?.actionName ||
                                        `Action ${actionNumber + 1}`}
                                </p>
                            )}
                            {isShowActionInput && (
                                <div className={styles.actionNameInputDiv}>
                                    {isShowError && (
                                        <p className={styles.actionNameError}>
                                            Action name character length must be
                                            less than or equal to 25!
                                        </p>
                                    )}
                                    <form onSubmit={handelActionSubmit}>
                                        <input
                                            ref={actionInputNameRef}
                                            type="text"
                                            className={styles.actionNameInput}
                                            value={inputActionValue}
                                            onChange={(e) =>
                                                setinputActionValue(
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </form>
                                </div>
                            )}
                        </div>
                        <p className={styles.tableBodyMarks}>
                            {action?.markerPositionTime || 0} S
                        </p>
                    </div>
                    {!isShowActionInput && (
                        <div className={styles.actionController}>
                            <img
                                className={styles.actionPlayBtn}
                                // width="25vw"
                                src={renderImage(
                                    isPlay ? 'pauseBtn' : 'playBtn'
                                )}
                                alt="play button"
                                onClick={playBtnClick}
                            />
                            <img
                                // width="25vw"
                                className={styles.actionPlayBtn}
                                src={renderImage('deleteBtn')}
                                alt="delete button"
                                onClick={deleteBtnClick}
                            />
                            <img
                                // width="25vw"
                                className={styles.actionPlayBtn}
                                src={renderImage('ActionCopyBtn')}
                                alt="copy button"
                                onClick={copyBtnClick}
                            />
                            <img
                                // width="25vw"
                                className={styles.actionPlayBtnEdit}
                                src={renderImage('editBlackIcon')}
                                alt="edit button"
                                onClick={(event) => {
                                    // event.stopPropagation()
                                    if (display !== 'none') {
                                        setIsShowActionInput(true)
                                    }
                                }}
                            />
                        </div>
                    )}
                </div>
                <div
                    className={`${styles.tableReadBtn}  ${
                        selectedAction === actionNumber && isMotorTorqueEnable
                            ? styles.enabledReadBtn
                            : styles.disabledReadBtn
                    }`}
                    onClick={handelReadBtnClick}
                >
                    <p style={{ marginBottom: '0' }}>Read</p>
                </div>
            </div>
            <div className={styles.tableBodyRight}>
                {action?.data &&
                    Object.keys(action?.data)?.map((key, ind) => {
                        return (
                            <div
                                key={(action?.id || '') + ind}
                                className={`${styles.tableCell}  ${styles.disabledBtn}`}
                                style={key == 'T' ? { cursor: 'default' } : {}}
                                onClick={() =>
                                    servoDetailsPopupOpen(key, actionNumber)
                                }
                            >
                                {key === 'T' && <div>Time</div>}
                                {key === 'H' && <div>H</div>}
                                {!['T', 'H'].includes(key) && <div>S{key}</div>}
                                <div style={{ marginTop: '0px' }}>
                                    {action?.data?.[key]?.value || 0}
                                </div>
                            </div>
                        )
                    })}
            </div>
        </div>
    )
}
export default ActionCreateTableRow
